<template>
    <div>
        <div class="relative">
            <validation-provider :rules="rules" v-slot="{ errors }">
                <input
                    class="py-3 px-4 text-lg lg:text-base text-gray-400 border border-gray-300 rounded w-full focus:border-blue-400 focus:outline-none"
                    :class="{ 'focus:border-red-400': errors[0], 'border-red-400': errors[0], 'bg-red-200': errors[0], 'padding-with-label': label !== '' }"
                    type="text"
                    :id="inputHtmlId"
                    :value="value"
                    @input="updateValue($event.target.value)"
                    @change="changeValue($event.target.value)"
                    autocomplete="off"
                >
                <label
                    :class="{ 'card-input-label--visible': show }"
                    :for="inputHtmlId"
                >{{ label }}</label>
                <span v-if="errors[0]" class="text-sm text-red-400 mt-1">{{ errors[0] }}</span>
            </validation-provider>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { ValidationProvider, extend } from 'vee-validate'
    import { required } from 'vee-validate/dist/rules'

    extend('required', {
        ...required,
        message: 'Det här fältet måste fyllas i'
    });

    export default {
        name: "CardInput",
        components: {ValidationProvider},
        props: ['label', 'value', 'rules'],
        data() {
            return {
                show: !this.isEmpty(this.value),
                inputHtmlId: _.uniqueId('card-input-')
            }
        },
        created() {
            this.$watch('value', (oldVal, newVal) => {
                this.show = !this.isEmpty(this.value)
                // this.show = this.value !== ''
            })
        },
        methods: {
            updateValue(value) {
                this.show = !this.isEmpty(value)
                // this.show = value !== '';

                this.$emit('input', value)
            },
            changeValue(value) {
                this.$emit('change', value)
            },
            isEmpty(value) {
                return !value || value === '';
            }
        }
    }
</script>

<style scoped>
    .padding-with-label {
        padding-bottom: 8px;
    }

    label {
        color: #707070;
        font-size: 14px;

        left: 16px;
        position: absolute;
        top: 12px;
        transition: all 0.1s linear;
    }

    input {
        width: 100%;
    }

    input:focus + label,
    input + label.card-input-label--visible {
        border-radius: 4px;
        left: 13px;
        top: -7px;
        background: #fff;
        padding: 0 5px;
        font-size: 10px;
        letter-spacing: 0.04em;
    }
</style>